import classNames from 'classnames';
import { calculatePodImageShiftingTransform } from './withSmokersHelpers';

const withSmokersSceneHelper = withSmokersScene => ({
  hasExited: withSmokersScene.progress() === 1,
});
const simpleSceneHelper = simpleScene => ({
  hasEntered: simpleScene.progress() > 0,
  isAnimating: simpleScene.progress() < 1,
  hasExited: simpleScene.progress() === 1,
});
const cleanSceneHelper = cleanScene => ({
  hasNotEntered: cleanScene.progress() === 0,
  isEnteringFromBottom: cleanScene.progress() < 0.95,
  hasEntered: cleanScene.progress() > 0,
  isAnimating: cleanScene.progress() > 0.1 && cleanScene.progress() <= 1,
  isExitingFromTop: cleanScene.progress() <= 0.1,
  isExitingFromBottom: cleanScene.progress() >= 0.95,
  hasExited: cleanScene.progress() === 1,
});
const satisfyingSceneHelper = satisfyingScene => ({
  hasEntered: satisfyingScene.progress() > 0,
  hasNotEntered: satisfyingScene.progress() === 0,
  isAnimating:
    satisfyingScene.progress() > 0.1 && satisfyingScene.progress() <= 1,
  hasExited: satisfyingScene.progress() === 1,
  isExitingFromTop: satisfyingScene.progress() <= 0.1,
});
const podImagePositionHelper = simpleScene => {
  // Transform value used for 'translateY` transform
  const podImageTransformPosition = calculatePodImageShiftingTransform(
    simpleScene.progress()
  );

  return { isBackToOrigin: podImageTransformPosition >= 40 };
};

export const getStarterKitClassNames = ({
  withSmokersScene,
  simpleScene,
  cleanScene,
  satisfyingScene,
}) => {
  const withSmokers = withSmokersSceneHelper(withSmokersScene);
  const simple = simpleSceneHelper(simpleScene);
  const clean = cleanSceneHelper(cleanScene);
  const satisfying = satisfyingSceneHelper(satisfyingScene);
  const podImagePosition = podImagePositionHelper(simpleScene);
  const isMobileScreen = window.innerWidth < 768;

  return {
    withSmokersAnimationClasses: classNames({
      'fade-text-out-up': withSmokers.hasExited && simple.hasEntered,
    }),
    simpleAnimationClasses: classNames({
      'fade-simple-text-in-up':
        (isMobileScreen &&
          podImagePosition.isBackToOrigin &&
          clean.hasNotEntered &&
          simple.hasEntered) ||
        (!isMobileScreen &&
          podImagePosition.isBackToOrigin &&
          simple.hasEntered &&
          withSmokers.hasExited),
      'fade-text-out-up':
        isMobileScreen && simple.hasExited && clean.hasEntered,
      'fade-text-out-down': simple.isAnimating,
    }),
    cleanAnimationClasses: classNames({
      // Fade away "Clean" on mobile only
      'fade-text-in-up':
        (isMobileScreen &&
          simple.hasExited &&
          clean.isExitingFromBottom &&
          satisfying.hasNotEntered) ||
        (!isMobileScreen && simple.hasExited && clean.isExitingFromBottom),
      'fade-text-out-up':
        isMobileScreen && satisfying.hasEntered && clean.hasExited,
      'fade-text-out-down': clean.isEnteringFromBottom,
    }),
    satisfyingAnimationClasses: classNames({
      'fade-text-in-up': satisfying.isAnimating && clean.hasExited,
      'fade-text-out-down': satisfying.isExitingFromTop,
    }),
    podImageClasses: classNames({
      'snap-pod-image': podImagePosition.isBackToOrigin,
    }),
    deviceImageClasses: classNames({
      'fade-image-out-up': satisfying.isAnimating && clean.hasExited,
      'fade-image-in': satisfying.isExitingFromTop,
    }),
    satisfyingPodsAnimationClasses: classNames({
      'fade-pods-in-up': satisfying.isAnimating && clean.hasExited,
      'fade-pods-out-down': satisfying.isExitingFromTop,
    }),
  };
};

export const getChargesAnywhereClassNames = ({ chargesAnywhereScene }) => {
  const sceneProgress = chargesAnywhereScene.progress();

  return {
    textAnimationClass: classNames({
      fadeInUp: sceneProgress > 0.1,
      fadeOutDown: sceneProgress <= 0.1,
    }),
    laptopAnimationClass: classNames({
      fadeInCharger: sceneProgress > 0.1,
      fadeOutCharger: sceneProgress <= 0.1,
    }),
    usbAnimationClass: classNames({
      fadeInUSB: sceneProgress > 0.1,
      fadeOutUSB: sceneProgress <= 0.1,
    }),
    deviceAnimationClass: classNames({
      fadeInDownDevice: sceneProgress >= 0.15,
      fadeUpOutDevice: sceneProgress < 0.15,
    }),
    podAnimationClass: classNames({
      fadeInDownPod: sceneProgress >= 0.15,
      fadeUpOutPod: sceneProgress < 0.15,
    }),
    deviceClickAnimation: classNames({
      deviceChargerSpring: sceneProgress >= 0.15,
    }),
  };
};
